// LP Ribbon — clones the marquee group once so the CSS translateX(0 → -50%) loop is seamless.

const initBlock = function( $block ) {
	$block.find( '.lp-marquee__track' ).each( function() {
		const $track = $( this );
		const $group = $track.children( '.lp-marquee__group' ).first();

		if ( $group.length ) {
			$track.append( $group.clone() );
		}
	} );
};

app.loadBlock( initBlock, 'section-lp-ribbon', '.section-lp-ribbon' );

// if ( module.hot ) {
// 	module.hot.accept();
// }
